(function() {
  'use strict';
  
  // Mobile search configuration
  const MOBILE_INITIAL_RESULTS = 4;
  const MOBILE_LOAD_MORE_COUNT = 20;
  let allProducts = [];
  let displayedCount = 0;
  
  function isMobile() {
    return window.innerWidth <= 767;
  }
  
  function initSearch() {
    // Toggle search modal
    const searchToggler = document.querySelectorAll('.search-opener');
    const searchModal = document.querySelector('.search-modal');
    const closeBtn = document.querySelector('.close-search');
    const clearBtn = document.querySelector('.search-bar .clear');
    const searchInput = document.getElementById('mobileSearchQuery');
    const productContainer = document.getElementById('product-container');

    console.log('Search init:', {
      togglerCount: searchToggler.length,
      hasModal: !!searchModal,
      hasInput: !!searchInput
    });

    function openModal() {
      if (searchModal) {
        searchModal.classList.add('opened');
        document.body.classList.add('modal-open');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 100);
        }
        console.log('Search modal opened');
      }
    }
    
    function closeModal() {
      if (searchModal) {
        searchModal.classList.remove('opened');
        document.body.classList.remove('modal-open');
        if (productContainer) productContainer.innerHTML = "";
        if (searchInput) searchInput.value = "";
        if (clearBtn) clearBtn.style.display = 'none';
        allProducts = [];
        displayedCount = 0;
        console.log('Search modal closed');
      }
    }
    
    function renderProductCard(product) {
      // Format price properly
      // Shopify's /search/suggest.json API returns price as a string already formatted (e.g., "24.00" or "1199.00")
      // NOT in cents - so we should NOT divide by 100
      let formattedPrice = '';
      if (product.price) {
        // Parse the price - it's already in the correct decimal format
        const priceNum = parseFloat(product.price);
        // Format with thousands separator
        formattedPrice = priceNum.toLocaleString('en-AE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      const imageSrc = product.image || product.featured_image || '';
      
      return `
        <div class="product-card">
          <a href="${product.url}" style="display: flex; align-items: center; gap: 0.8rem; text-decoration: none; width: 100%;">
            ${imageSrc ? `<img src="${imageSrc}" alt="${product.title}" loading="lazy">` : '<div class="product-placeholder"></div>'}
            <div class="product-info">
              <h3 class="product-title">${product.title}</h3>
              ${formattedPrice ? `<p class="product-price">AED ${formattedPrice}</p>` : ''}
            </div>
          </a>
        </div>
      `;
    }
    
    function renderLoadMoreButton(remainingCount, query) {
      return `
        <a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-load-more">
          View all results
        </a>
      `;
    }
    
    function renderProducts(products, showAll = false, searchQuery = '') {
      if (!productContainer) return;
      
      allProducts = products;
      const isMobileView = isMobile();
      
      if (products.length === 0) {
        productContainer.innerHTML = '<div class="search-no-results">No products found</div>';
        return;
      }
      
      // On mobile, limit initial display
      const productsToShow = (isMobileView && !showAll) 
        ? products.slice(0, MOBILE_INITIAL_RESULTS) 
        : products;
      
      displayedCount = productsToShow.length;
      
      let html = productsToShow.map(renderProductCard).join('');
      
      // Add "View All" link on mobile if there are more products
      if (isMobileView && products.length > displayedCount) {
        html += renderLoadMoreButton(products.length - displayedCount, searchQuery);
      }
      
      productContainer.innerHTML = html;
    }

    if (searchToggler.length > 0) {
      searchToggler.forEach(single => {
        single.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Search opener clicked');
          openModal();
          return false;
        }, false);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    }

    // Dismiss modal on escape
    document.addEventListener('keydown', function(e){
      if (e.key === "Escape" && searchModal && searchModal.classList.contains('opened')) {
        closeModal();
      }
    });

    // Close modal when clicking on the overlay (backdrop)
    if (searchModal) {
      searchModal.addEventListener('click', function(e) {
        // Only close if clicking directly on the modal (the overlay), not its children
        if (e.target === searchModal || e.target.classList.contains('search-modal')) {
          closeModal();
        }
      });
    }

    // Handle search
    let debounceTimeout;
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const query = searchInput.value.trim();
        if (clearBtn) clearBtn.style.display = query ? 'inline-block' : 'none';

        clearTimeout(debounceTimeout);
        if (!query) {
          if (productContainer) productContainer.innerHTML = "";
          allProducts = [];
          displayedCount = 0;
          return;
        }
        
        debounceTimeout = setTimeout(() => {
          // Show loading state
          if (productContainer) {
            productContainer.innerHTML = '<div class="search-loading">Searching...</div>';
          }
          
          // Fetch more results on mobile to support load more
          const limit = isMobile() ? 24 : 8;
          
          fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit}`)
            .then(res => res.json())
            .then(data => {
              if (data.resources && data.resources.results && data.resources.results.products) {
                renderProducts(data.resources.results.products, false, query);
              } else {
                if (productContainer) {
                  productContainer.innerHTML = '<div class="search-no-results">No results found</div>';
                }
              }
            })
            .catch(err => {
              console.error('Search error:', err);
              if (productContainer) {
                productContainer.innerHTML = '<div class="search-error">Search error. Please try again.</div>';
              }
            });
        }, 300);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (searchInput) searchInput.value = "";
        if (productContainer) productContainer.innerHTML = "";
        clearBtn.style.display = 'none';
        if (searchInput) searchInput.focus();
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }
})();
